import React from "react";
import { Link } from "react-router-dom";
import { Carousel } from "react-bootstrap";

let newResidentialsimgPath = require.context("../../public/images/newResidential", true);
let remodelsimgPath = require.context("../../public/images/remodels", true);
let commercialimgPath = require.context("../../public/images/commercial", true);

const serviceSlides = [
	commercialimgPath("./Howard, Burlingame, CA3.jpg"),
	remodelsimgPath("./25th Avenue, San Francisco, CA3.jpg"),
	newResidentialsimgPath("./Trinidad Dr, Tiburon, CA7.jpg"),
	newResidentialsimgPath("./Pullman Avenue, Half Moon Bay, CA13.jpg"),
	commercialimgPath("./N. Lenore, Willits, CA (2 Buildings)5.jpg"),
	newResidentialsimgPath("./Pullman Avenue, Half Moon Bay, CA12.jpg"),
	newResidentialsimgPath("./Pullman Avenue, Half Moon Bay, CA11.jpg"),
	newResidentialsimgPath("./Skyfarm Drive, Santa Rosa, CA2.jpg"),
	remodelsimgPath("./25th Avenue, San Francisco, CA6.jpg"),
	commercialimgPath("./N. Lenore, Willits, CA (2 Buildings)4.jpg"),
	newResidentialsimgPath("./Pullman Avenue, Half Moon Bay, CA10.jpg")
];

const Services = () => {
	return (
		<main className="services-page">
			<section className="page-hero-image services-hero-image slideshow-page-hero">
				<Carousel indicators={false} controls={false} interval={3500} pause={false} fade>
					{serviceSlides.map((slide, index) => (
						<Carousel.Item key={index}>
							<img src={slide} alt="NY Engineering services slideshow" />
						</Carousel.Item>
					))}
				</Carousel>
				<div className="page-hero-overlay" />
				<div className="site-container page-hero-copy">
					<h1 className="page-title">Services</h1>
					<p>NY Engineering delivers comprehensive structural engineering solutions for residential, commercial, and seismic retrofit projects, including steel, concrete, foundation, and retaining wall design.</p>
				</div>
			</section>

			<div className="site-container service-detail-list">
				<article className="service-detail-row">
					<h2>New Construction and Commercial</h2>
					<p>One of our most fundamental services we offer is ground-up design and construction. Whether it is a residential or commercial building, we have the skills and credentials to design and construct your building or structure. Starting with a solid, concrete foundation, we use concrete and masonry for retaining walls and use wood for the frame. From our careful design process to our efficient construction teams, we can find a solution for any project that you may have.</p>
				</article>
				<article className="service-detail-row">
					<h2>Rear and Story Additions</h2>
					<p>Sometimes you just need more room or need to build an extra garage or tool shed. Whatever your needs may be, it may be too much to design and construct the project yourself. Our specialty is to safely and reliably perform renovations, additions, and remodeling of any kind. We have done work using wood, Concrete, Simpson Strong Wall, and Hardy Panels, preferring to avoid steel for more economical solutions. Whether it's a simple remodel for a room or an entire new story, our firm is equipped to handle any remodel project.</p>
				</article>
				<article className="service-detail-row">
					<h2>Soft Story Seismic Retrofits</h2>
					<p>Some buildings are just too old to be in compliance with modern seismic regulations. Though this service is mostly for multi-units and commercial properties, any building that needs to be retrofitted to be in compliance with the most recent regulations will need this service. We prefer to use wood or Simpson Strong Wall to accomplish this, but we can use seismic steel moment frames if the architecture cannot be compromised. While this is a relatively new service to be offered, it is undoubtedly an important one that we expect to see much more of in the future.</p>
				</article>

				<section className="additional-services">
					<div>
						<h2>Additional Structural Engineering Services</h2>
						<p>We are consulting structural engineers with extensive experience, providing cost-effective and high-quality work in the following areas:</p>
					</div>
					<ul>
						<li>Residential Structural Engineering<small>Additions, remodels, and new construction.</small></li>
						<li>Concrete or Masonry Retaining Wall Design</li>
						<li>Steel Design</li>
						<li>Seismic Retrofit of Existing Building</li>
						<li>Concrete Foundation Design</li>
						<li>Office Buildings, Industrial Facilities, Retail / Wholesale Spaces, and Warehouses</li>
					</ul>
				</section>
			</div>
			<section className="page-cta">
				<div className="site-container page-cta-inner">
					<p>We work with owners, architects, contractors, and designers. Please contact us for any structural engineering needs.</p>
					<Link className="button button-dark" to="/contact">Contact Us →</Link>
				</div>
			</section>
		</main>
	);
};

export default Services;
